import React, { Component } from 'react'
import styled from 'styled-components'
import { getTheme } from '../../global/utils'
import logo from '../../img/logo-inverse.svg'
import SideNavItem from './SideNavItem'
import Heading from '../text/Heading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faGlobe,
    faBell,
    faServer,
    faTachometerAlt,
    faDownload,
    faQuestionCircle,
    faFileDownload,
    faLink,
} from '@fortawesome/free-solid-svg-icons'
import axios from "axios/index";

const Sidebar = styled.div`
  min-height: 100vh;
  background-color: ${getTheme('bg', 'dark1')};
  color: ${getTheme('textColor', 'alt')};
  padding-top: ${getTheme('spacer', 'l')};
  padding-bottom: ${getTheme('spacer', 'l')};

  .sidenav__logo {
    margin-bottom: ${getTheme('marginBottom', 'xl')};
    padding-left: ${getTheme('padding', 'horizontalNav')};
  }
  .navgroup {
    padding: 0;
    margin: 0;
  }
  .navgroup__title {
    display: block;
    margin: 0 ${getTheme('padding', 's')};
    padding-left: ${getTheme('padding', 'horizontalNav')};
    padding-top: ${getTheme('padding', 'verticalL')};
    border-top: 1px solid ${getTheme('textColor', 'altLight')};
    font-weight: 700;
  }
`;

class SideNav extends Component {

    constructor() {
        super();

        this.state = {
            url_atenea: '#',
            url_sftpalarms: '#'
        };
    };

    componentDidMount() {
        axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
        axios.defaults.xsrfCookieName = "csrftoken";
        axios.defaults.withCredentials = true;
        const url = process.env.REACT_APP_API_SERVER+'/api/v01/external/urls/';
        axios.get(url)
          .then(res => {
              this.setState({url_atenea: res.data.url_atenea});
              this.setState({url_sftpalarms: res.data.url_sftpalarms});
          });
      }
    render() {
        return (
          <Sidebar>
            <img
              src={logo}
              alt="CAF - Aunia Friendly Tool Set"
              className="sidenav__logo"
            />
            <nav>
              <ul className="navgroup">
                {/* <SideNavItem
                  text="Projects"
                  url="/projects"
                  icon={<FontAwesomeIcon icon={faFolder} />}
                /> */}
                <SideNavItem rol='clw' text="Map" url="/projects" icon={<FontAwesomeIcon icon={faGlobe} />} />
                <SideNavItem rol='cbm' text="Snapshots" url="/snapshots" icon={<FontAwesomeIcon icon={faBell} />} />
              </ul>
              <Heading level="heading6">
                <span className="navgroup__title">aunia</span>
              </Heading>
              <ul className="navgroup">
                <SideNavItem
                  text="Status"
                  url="#"
                  icon={<FontAwesomeIcon icon={faServer} />}
                  disabled
                />
                <SideNavItem
                  text="Usage"
                  url="#"
                  icon={<FontAwesomeIcon icon={faTachometerAlt} />}
                  disabled
                />
                <SideNavItem
                  text="Releases"
                  url="#"
                  icon={<FontAwesomeIcon icon={faDownload} />}
                  disabled
                />
                <SideNavItem
                  text="Feedback"
                  url="#"
                  icon={<FontAwesomeIcon icon={faServer} />}
                  disabled
                />
                <SideNavItem
                  text="Helpcenter"
                  url="#"
                  icon={<FontAwesomeIcon icon={faQuestionCircle} />}
                  disabled
                />
              </ul>
              <Heading rol='clw' level="heading6">
                <span className="navgroup__title">Links</span>
              </Heading>
              <ul className="navgroup">
                <SideNavItem
                  rol='clw'
                  text="Alarms"
                  url={this.state.url_atenea}
                  external
                  icon={<FontAwesomeIcon icon={faLink} />}
                />
                <SideNavItem
                  rol='clw'
                  text="File Download"
                  url={this.state.url_sftpalarms}
                  external
                  icon={<FontAwesomeIcon icon={faFileDownload} />}
                />
              </ul>
            </nav>
          </Sidebar>
        )
    }
}

export default SideNav



// WEBPACK FOOTER //
// ./src/components/navs/SideNav.js